(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footle-recipient-welcome"]) return;
  try {
    
  (() => {
    const enableCopy = () => {
      document.querySelectorAll('[data-welcome-copy]').forEach((button) => { button.hidden = false; });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enableCopy, { once: true });
    } else {
      enableCopy();
    }
    document.addEventListener('shopify:section:load', enableCopy);
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-welcome-copy]');
      if (!button) return;
      const container = button.closest('[data-welcome-email]');
      const input = container.querySelector('input');
      const status = container.querySelector('[role="status"]');
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(input.value);
        status.textContent = button.dataset.copied;
      } catch {
        input.focus();
        input.select();
        input.setSelectionRange(0, input.value.length);
        status.textContent = button.dataset.fallback;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
